import DataTable from "react-data-table-component";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./customThemes";

const CommonDataTable = ({
  columns,
  data,
  customStyles,
  recordTotal,
  pageNo,
  pageSize,
  handlePageNo,
  handlePageSizeChange,
  handleSort,
  loading,
  enablePagination = false,
  noDataComponent,
  rowsPerPageOptions
}) => {
  return (
    <DataTable
      columns={columns}
      data={data || []}
      customStyles={customStyles}
      fixedHeader
      responsive
      fixedHeaderScrollHeight="calc(100vh - 280px)"
      pagination={enablePagination}
      paginationServer={enablePagination}
      paginationRowsPerPageOptions={rowsPerPageOptions}
      paginationTotalRows={enablePagination ? (recordTotal ?? data.length) : undefined}
      paginationDefaultPage={enablePagination ? pageNo : undefined}
      paginationPerPage={enablePagination ? pageSize : undefined}
      onChangePage={enablePagination ? handlePageNo : undefined}
      onChangeRowsPerPage={enablePagination ? handlePageSizeChange : undefined}
      onSort={(column, sortDirection) =>
        handleSort && handleSort(column?.columnName || column?.name, sortDirection)
      }
      theme="darkTransparent"
      progressPending={loading}
      progressComponent={
        <div className="w-100">
          <Skeleton count={10} height={30} width="100%" />
        </div>
      }
      noDataComponent={
        !loading && (!data || data.length === 0) ? <h5>No Records Found!</h5> : <></>
      }
    />
  );
};

export default CommonDataTable;
